/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostVideoMultiPartUploadSignedurlRequest
 */
export interface PostVideoMultiPartUploadSignedurlRequest {
    /**
     * 
     * @type {string}
     * @memberof PostVideoMultiPartUploadSignedurlRequest
     */
    fileName: string;
    /**
     * 
     * @type {number}
     * @memberof PostVideoMultiPartUploadSignedurlRequest
     */
    fileSize: number;
    /**
     * 
     * @type {string}
     * @memberof PostVideoMultiPartUploadSignedurlRequest
     */
    oneTimePassword: string;
}

/**
 * Check if a given object implements the PostVideoMultiPartUploadSignedurlRequest interface.
 */
export function instanceOfPostVideoMultiPartUploadSignedurlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "oneTimePassword" in value;

    return isInstance;
}

export function PostVideoMultiPartUploadSignedurlRequestFromJSON(json: any): PostVideoMultiPartUploadSignedurlRequest {
    return PostVideoMultiPartUploadSignedurlRequestFromJSONTyped(json, false);
}

export function PostVideoMultiPartUploadSignedurlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostVideoMultiPartUploadSignedurlRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'fileSize': json['fileSize'],
        'oneTimePassword': json['oneTimePassword'],
    };
}

export function PostVideoMultiPartUploadSignedurlRequestToJSON(value?: PostVideoMultiPartUploadSignedurlRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'fileSize': value.fileSize,
        'oneTimePassword': value.oneTimePassword,
    };
}

